import React from 'react';

import { Typography } from '@material-ui/core';

/**
 * @param prefix text to render before bolded string
 * @param boldedText bolded text in middle of string
 * @param suffix text to render after bolded string
 * @returns span with boldedText bolded and separated by space from prefix and suffix
 */
export const renderInlineBoldedWordText = (prefix: string, boldedText: string, suffix: string): JSX.Element => (
  <Typography variant={'inherit'}>
    {prefix}
    &nbsp;
    <Typography variant={'inherit'} component={'strong'}>
      {boldedText}
    </Typography>
    &nbsp;
    {suffix}
  </Typography>
);
